import * as React from 'react'
import { Link } from 'react-router-dom'
import { Redirect } from 'react-router'
import { connect } from 'react-redux'
import {toastr} from 'react-redux-toastr'

import './../styles/auth/auth.css'
import logo from './../images/logo.png'
import {Button, TYPES} from './../components/shared/button'
import {login} from  './../redux/actions/auth'
import {passUserDataForDemoAccount} from './../redux/actions/visits'


class Login extends React.Component {
  constructor() {
    super()

    this.state={
      email: '',
      password: '',
    }
  }

  onSubmit = event => {
    event.preventDefault()
    this.props.login(this.state.email, this.state.password).catch(error => {
      toastr.error('Error', 'Incorrect email or password')
    })
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  authForm = () => {
    let redirectRoute = '/visits'
    if(this.props.location.state !== undefined) {
      redirectRoute = this.props.location.state.from.pathname
    }
    if(this.props.isAuthenticated) {
      if(this.props.state.auth.user.is_verifier)   {
        redirectRoute = '/verification'
      }
      this.props.passUserDataForDemoAccount()
      return (
        <Redirect to={redirectRoute} />
      )
    } else {
      return (
          <div className='auth-box'>
          <img src={logo} alt='BayWatch Technologies' />
            <form onSubmit={this.onSubmit} >
              <input type='email' placeholder='Email' name='email' onChange={this.handleChange} className='auth-input'/>
              <input type='password' placeholder='Password' name='password' onChange={this.handleChange} className='auth-input'/>
              <div className='auth-button-container'>
                <Button
                  text='Login'
                  type='logIn'
                  buttonType={TYPES.SUBMIT}
                />
              </div>
            </form>
            <div className='auth-password-reset'>
             <p>Forgot password?</p>
             <Link to="/password-reset">Reset Password</Link>
            </div>
          </div>
      )
    }
  }

  render () {
    return (
      <div className='auth-container'>
       {this.authForm()}
      </div>
    )
  }
}

const mapStateToProps = state => {
  let errors = []
  if (state.auth.errors) {
    errors = Object.keys(state.auth.errors).map(field => {
    return {field, message: state.auth.errors[field]}
    })
  }
  return {
    state,
    errors,
    isAuthenticated: state.auth.isAuthenticated
  };
}

const mapDispatchToProps = dispatch => {
  return {
    login: (email, password) => {
      return dispatch(login(email, password));
    },
    passUserDataForDemoAccount: () => {
      return dispatch(passUserDataForDemoAccount());
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/pages/login.js